import { useEffect, useState } from "react";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { getSubSystemList } from "../../services/about/about.service";
import styles from "./SubCompany.module.css";
import Title from "../../components/title";
let unlisten;

const SubCompany = () => {
  const [aboutList, setAboutList] = useState(null);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [tabContent, setTabContent] = useState(null);
  const [tabTitle, setTabTitle] = useState(null);
  const [activeLogo, setActiveLogo] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "سهامداران", url: "/partners" },
      { title: "شرکت های تابعه", url: "/partners/companies" },
    ]);
    getSubSystemList().then(({ data }) => {
      setAboutList((data && data.data) || []);
      setActiveLogo(
        data.data[activeIndex].attachment_files[0].server_relative_url
      );
      setTabContent(data.data[activeIndex].rich_description);
      setTabTitle(data.data[activeIndex].title);
    });
    return () => {
      try {
        unlisten();
      } catch (e) {}
    };
  }, [activeIndex]);

  const changeTabContent = (index) => {
    setActiveLogo(aboutList[index].attachment_files[0].server_relative_url);
    setTabContent(aboutList[index].rich_description);
    setTabTitle(aboutList[index].title);
    setActiveIndex(index);
  };

  return (
    <>
      <Title title={"شرکت های تابعه"} />
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />

        <div className={"row"}>
          <div className={"col-xs-12 col-md-8"}>
            <div className={styles.subCompanyWrapper}>
              {tabContent ? (
                <>
                  {activeLogo ? (
                    <div className={styles.subsystemLogo}>
                      <img src={activeLogo} alt={"logo"} />
                    </div>
                  ) : null}
                  <div className={"clearfix"} />
                  <h1 className={styles.tabTitle}>
                    {tabTitle ? tabTitle : null}
                  </h1>
                  <div
                    id={styles.tabContent}
                    className={styles.eventsTabDescription}
                    dangerouslySetInnerHTML={{ __html: tabContent }}
                  ></div>
                </>
              ) : (
                <div className="loading-wrapper">
                  <img
                    src={"../../../assets/image/loading.svg"}
                    alt={"در حال بار گذاری"}
                  />
                </div>
              )}
            </div>
          </div>
          <div className={"col-xs-12 col-md-4"}>
            <h2 className={styles.sidebarAboutTitle}>شرکت های تابعه</h2>
            {aboutList && aboutList.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {aboutList.map((item, index) => (
                  <li
                    onClick={() => changeTabContent(index)}
                    className={index === activeIndex ? styles.active : ""}
                    key={index + "-key-tab-box"}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            ) : (
              <div className="loading-wrapper">
                <img
                  src={"../../../assets/image/loading.svg"}
                  alt={"در حال بار گذاری"}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default SubCompany;
